import { isAxiosError } from 'axios';
import React from 'react';
import { useNavigate, useLocation, useParams } from 'react-router-dom';

import { useAppDispatch } from '@shared/hooks';

import { shopService } from 'library/api/shopService';
import type { Order } from 'library/models/shop';
import { openNotifyModal } from 'library/redux/modal';
import { clearShop } from 'library/redux/shop';

import { useCertificateMessage } from '../common';

const useOrder = () => {
	const dispatch = useAppDispatch();
	const navigate = useNavigate();
	const { state } = useLocation();
	const { id = '' } = useParams();
	const [isPaymentOpen, setIsPaymentOpen] = React.useState(false);
	const [order, setOrder] = React.useState<Order>({} as Order);
	const { code } = useParams<{ code: string }>();
	const { onRedirect } = useCertificateMessage();

	const repeatPayment = async () => {
		// setIsPaymentOpen(true);
		try {
			const response = await shopService.buyProduct(order.id);
			if (!response.data) {
				throw response;
			}

			// setUrl(response.data.redirect_url);

			if (response.data.redirect_url) {
				return response.data.redirect_url;
			}
		} catch (err) {
			setIsPaymentOpen(false);

			if (isAxiosError(err) && err.response?.status === 400) {
				if (err.response.data[0].message === 'Product position absent in storage') {
					dispatch(
						openNotifyModal({
							title: '',
							text: 'Недостаточно товара на складе',
							confirmText: 'Ок',
						})
					);
				}
			}
		}
	};

	const onPaySuccess = async () => {
		const id = order.id;

		try {
			await shopService.confirmOrderFront(id);
		} catch (error) {}
		setIsPaymentOpen(false);
		dispatch(clearShop());
		navigate('/store/orders');
		dispatch(
			openNotifyModal({
				title: '',
				text: 'Ваш заказ успешно оплачен',
				confirmText: 'Ок',
			})
		);
	};

	React.useEffect(() => {
		state?.order
			? setOrder(state.order)
			: shopService.getOrder(id).then((res) => {
					setOrder(res.data);
			  });
	}, [state, id]);

	const closeModal = () => {
		navigate(`/shop/${code}/orders`);
	};

	return {
		closeModal,
		order,
		repeatPayment: () => onRedirect(repeatPayment),
		isPaymentOpen,
		setIsPaymentOpen,
		onPaySuccess,
	};
};

export default useOrder;
